export type SetupStep = 'data' | 'goals' | 'review';
export type DataTab = 'participants' | 'dnm' | 'coaches';

export const SETUP_STEPS: { id: SetupStep; label: string; next: string }[] = [
  {
    id: 'data',
    label: 'Configure data',
    next: 'Continue to group requirements and matching goals',
  },
  {
    id: 'goals',
    label: 'Group requirements and matching goals',
    next: 'Continue to review',
  },
  { id: 'review', label: 'Review and confirm', next: 'Start matching' },
];

/** Where an issue's Fix link goes. */
export interface IssueTarget {
  step: SetupStep;
  dataTab?: DataTab;
  goalColumn?: string;
  /** Filter the participants table to people with unrecognized do-not-match emails. */
  onlyUnrecognizedDnm?: boolean;
}

export interface SetupIssue {
  text: string;
  /** Blocking issues stop Start matching; the rest are warnings to review. */
  blocks: boolean;
  target: IssueTarget;
}
